/** @jsx jsx */
import { jsx } from '@emotion/react';
import tw from 'twin.macro';

const Label = tw.label`
inline-block text-xs text-gray-700
`;

export default Label;
